<template>
  <div>
    <vs-popup
      title="Sincronização de Mensagens"
      :button-close-hidden="false"
      :active.sync="isActive"
      @close="$emit('isActiveFalse')"
    >
      <div style="margin-bottom: 1em">
        <p class="mb-2">Quantidade de dias:</p>
        <v-select
          v-model="selectedQuantityDays"
          class="w-full"
          :options="quantityDays"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>

      <div class="d-flex">
        <vs-checkbox v-model="unlimitedSync">
          <p class="font-medium"> Sincronização Ilimitada </p>
        </vs-checkbox>
        <vx-tooltip
          id="tooltip"
          color="warning"
          text="ATENÇÃO: Esta opção deve ser marcada SOMENTE em casos de sincronização de histórico de clientes que migrarão para a API Cloud.
            Isso porque, com essa opção ativa, a sincronização não possui limitações e pode gerar alta carga na infraestrutura, causando instabilidade ou lentidão no sistema.
          "
          delay=".2s"
        >
          <feather-icon icon="AlertTriangleIcon" svgClasses="w-7 h-7 text-warning"></feather-icon>
        </vx-tooltip>
      </div>

      <br />
      <div style="text-align: right">
        <span>
          <vs-button
            size="medium"
            color="danger"
            @click="$emit('isActiveFalse')"
          >
            <span> Cancelar </span>
          </vs-button>
        </span>
        <span>
          <vs-button
            class="ml-4"
            size="medium"
            color="success"
            @click="syncMessagesInstance"
          >
            <span> Atualizar </span>
          </vs-button>
        </span>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { VTree, VSelectTree } from "vue-tree-halower";
import instanceHttp from "./../../http/requests/connections/index";

export default {
  name: "SyncMessagesInstance",
  components: {
    vSelect,
    VTree,
    VSelectTree,
  },
  data() {
    return {
      selectedQuantityDays: {
        label: "60",
        value: 60,
      },
      quantityDays: [
        {
          label: "5",
          value: 5,
        },
        {
          label: "15",
          value: 15,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "60",
          value: 60,
        },
        {
          label: "120",
          value: 120,
        },
      ],
      unlimitedSync: false,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    instance: {
      type: Object | Array,
      required: true,
    },
    tenantName: {
      type: String,
      required: true,
    },
  },
  emits: ["isActiveFalse", "successfullyUpdated"],
  watch: {
    isActive(value) {
      if (value) {
        this.unlimitedSync = false;
      }
    }
  },
  methods: {
    verify() {
      const permissions = localStorage.getItem("permissions");
      const twoFactor = localStorage.getItem("twoFactor");
      if (!permissions && !twoFactor) {
        this.$router.push("/user-settings");
      } else if (!permissions && twoFactor) {
        this.$router.push("/two-factor");
      }
    },
    async syncMessagesInstance() {
      await instanceHttp.syncMessages(
        this.instance.id,
        this.selectedQuantityDays.value,
        localStorage.getItem("accessToken"),
        this.tenantName,
        this.unlimitedSync
      ).then((response) => {
        if (response.data.data.syncInstanceChats) {
          this.$vs.notify({
            title: "Sucesso!",
            text: "Sincronização de mensagem executada com sucesso!",
            color: "success",
          });
        } else {
          this.$vs.notify({
            title: "Erro!",
            text: "Algo deu errado ao tentar sincronizar as mensagens!",
            color: "warning",
          });
        }

        return this.$emit("successfullyUpdated");
      }).catch((exception) => {
        console.error(exception);
        this.$vs.notify({
          title: "Erro!",
          text: "Algo deu errado ao tentar sincronizar as mensagens!",
          color: "danger",
        });
      });
    },
    closePopUpSyncMessages() {
      this.$emit("isActiveFalse");
    },
  },
  mounted() {
    this.verify();
  },
  created() {
    this.$events.on("closePopUpSyncMessages", this.closePopUpSyncMessages);
  },
  beforeDestroy() {
    this.$events.off("closePopUpSyncMessages", this.closePopUpSyncMessages);
  },
};
</script>

<style lang="scss">
.align-check-box-update-instance {
  display: flex;

  > div:last-of-type {
    margin-left: 30px;
  }
}
.vs-tooltip-warning {
  z-index: 999999;
}
</style>